import { Type } from '@sinclair/typebox';
export const OwnerProfileSchema = Type.Object({
    delugeId: Type.String(),
    username: Type.String(),
    avatar: Type.Optional(Type.String()),
});
//# sourceMappingURL=owner-profile.js.map